import ApplicationController from "../application_controller";

class TemplatePreviewsController extends ApplicationController {
  connect() {
    $(this.element).on('click', (e) => {
      e.preventDefault()

      let interviewTemplateModal = $('#appraisals_interview_template_preview')
      let interviewTemplateForm = document.getElementById('appraisal_interview_template_form')

      let formUrl = $(this.element).attr('href')
      let formData = new FormData(interviewTemplateForm)

      $.ajax({
        url: formUrl,
        data: formData,
        processData: false,
        contentType: false,
        method: 'PATCH',
        success: function(data){
          interviewTemplateModal.find('.modal-body').html(data.template)
          interviewTemplateModal.modal('show')
        }
      });
    })
  }
}

export default TemplatePreviewsController
